module.exports = __webpack_public_path__ + "static/media/chip.e1ef41d2.svg";